import { clsx } from 'clsx'
import React, { forwardRef } from 'react'

const styles = {
  base: [
    // Basic layout
    'relative isolate',
    // Typography
    'font-semibold tracking-tight text-gray-900 dark:text-white',
  ],
  size: {
    lg: 'text-lg/7',
    xl: 'text-xl/8',
    '2xl': 'text-2xl/9',
    '3xl': 'text-3xl/10',
    '4xl': 'text-4xl/11',
    '5xl': 'text-5xl/12',
    '6xl': 'text-6xl/13',
  },
  weight: {
    normal: 'font-normal',
    medium: 'font-medium',
    semibold: 'font-semibold',
    bold: 'font-bold',
  },
}

export const Heading = forwardRef(function Heading(
  {
    as: Component = 'h1',
    className,
    size = '3xl',
    weight = 'semibold',
    ...props
  }: {
    as?: React.ElementType
    className?: string
    size?: 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | '6xl'
    weight?: 'normal' | 'medium' | 'semibold' | 'bold'
  } & React.ComponentPropsWithoutRef<'h1'>,
  ref: React.ForwardedRef<HTMLHeadingElement>
) {
  return (
    <Component
      {...props}
      className={clsx(
        styles.base,
        styles.size[size],
        styles.weight[weight],
        className
      )}
      ref={ref}
    />
  )
})
